/**
 * Sample dashboard data.
 *
 * Placeholder numbers only, shaped like what useComparisonRows() /
 * summarizeRows() (see useWipComparison.js) compute from real SSS
 * schedules + TRS time entries. The real charts can be wired in later by
 * swapping this import for that computed data -- the chart components
 * themselves won't need to change.
 */

export const sampleSummary = {
  total_scheduled_hours: 18420,
  total_actual_hours: 19110,
  net_hour_variance: 690,
  total_wip_cost_variance: 24850,
  unscheduled_actuals_count: 14,
};

export const sampleHoursByBranch = [
  { branch: 'HQ', scheduled: 6200, actual: 6480 },
  { branch: 'Toul Kork', scheduled: 3100, actual: 2950 },
  { branch: 'BKK1', scheduled: 2800, actual: 3020 },
  { branch: 'Siem Reap', scheduled: 2400, actual: 2260 },
  { branch: 'Sihanoukville', scheduled: 1920, actual: 2050 },
  { branch: 'Battambang', scheduled: 2000, actual: 2350 },
];

export const sampleVarianceTrend = [
  { week: 'W1', variance: 120 },
  { week: 'W2', variance: -60 },
  { week: 'W3', variance: 210 },
  { week: 'W4', variance: 340 },
  { week: 'W5', variance: -90 },
  { week: 'W6', variance: 690 },
];

export const sampleStatusBreakdown = [
  { status: 'On-Track', count: 142, color: '#34d399' },
  { status: 'Over-Budget', count: 31, color: '#fbbf24' },
  { status: 'Unscheduled', count: 14, color: '#fb7185' },
  { status: 'No-Show', count: 9, color: '#94a3b8' },
];

export const sampleTopEngagements = [
  { engagement: 'ABC Bank FY26 Audit', client: 'ABC Bank Plc', costVariance: 8420 },
  { engagement: 'Mekong Retail Group Audit', client: 'Mekong Retail Group', costVariance: 5310 },
  { engagement: 'Golden Land Interim Review', client: 'Golden Land Co.', costVariance: 3980 },
  { engagement: 'Angkor Beverages Tax Advisory', client: 'Angkor Beverages', costVariance: -2140 },
  { engagement: 'Riverside Hotels Audit', client: 'Riverside Hotels Ltd', costVariance: 2760 },
];
